<template>
  <div class="dashboard">
    <!-- Header Section -->
    <!--
          <div class="header">
      <h1>Ticket System Dashboard</h1>
      <p>Welcome back! Here's your current system overview.</p>
    </div>
    -->
    <!-- Top Row: Adjacent Metric Cards TODO LIST-->
    <div class="metrics-row">
      <!-- Ticket Metrics Card -->
      <div class="metric-card">
        <div class="metric-header">
          <div class="metric-icon tickets">
            <img style="width: 114%; padding-top:10px" src="../../static/image/leftbar_menu/icon_TASK_notext.svg" alt="Task"/>
          </div>
          <div class="metric-title">Ticket Metrics</div>

          <b-button class="ml-2" size="sm" variant="primary" @click="getStatusOverview(); changeUpdateStatus(false)">
            <b-icon icon="arrow-repeat" class="me-1"></b-icon>
            Sync
          </b-button>
        </div>
        <span class="text-danger" v-if="hasUpdate">Update available</span>
        <div class="metric-item" v-if="unreadFTIEs.length>0">
          <span class="metric-label">Unread FTIE</span>
          <b-button class="metric-value assigned" @click="showFtieDetails">
            {{ unreadFTIEs.length }}
          </b-button>
          <b-modal id="ftie-modal" v-model="ftieModalVisible" size="sm" title="Unread FTIE">
            <b-table striped hover :items="unreadFTIEs" :fields="ftieFields">
              <template #cell(FTIE_ID)="data">
                <div class="row">
                  <div class="col-4 align-self-end">
                    <a class="link" target="_blank" @click="changeUpdateStatus(true)" :href="`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.FTIE_ID }`">{{ data.item.FTIE_ID }}</a>
                  </div>
                </div>
              </template>

            </b-table>
          </b-modal>
        </div>

        <div class="metric-item" v-if="pendingNREs.length>0">
          <span class="metric-label">Pending NRE</span>
          <b-button class="metric-value pending" @click="showNreDetails">
            {{ pendingNREs.length }}
          </b-button>
          <b-modal id="nre-modal" v-model="nreModalVisible" size="sm" title="Pending NRE">
            <b-table striped hover :items="pendingNREs" :fields="nreFields">
              <template #cell(NRE_ID)="data">
                <div class="row">
                  <div class="col-4 align-self-end">
                    <a class="link" target="_blank" @click="changeUpdateStatus(true)" :href="`${ frontEndUrlToUse }${data.item.FUNCTION}/${data.item.FTIE_ID}/${data.item.SKU_ID}/${data.item.NRE_ID}/${data.item.REAL_SKU_NO}/${ data.item.APPROVAL_GULID }`">{{ data.item.NRE_ID }}</a>
                  </div>
                </div>
              </template>

            </b-table>
          </b-modal>
        </div>
        <!--<div class="metric-item">
    <span class="metric-label">RD Check Item</span>
    <span class="metric-value pending">{{ pendingNREs.length }}</span>
  </div>-->
        <!--<div class="metric-item">
    <span class="metric-label">Overdue</span>
    <span class="metric-value overdue">{{ ticketMetrics.overdue }}</span>
  </div>-->
      </div>

      <!-- Required Actions Card -->
      <div class="metric-card">
        <div class="metric-header">
          <div class="metric-icon actions">
            <img style="width: 120%; padding-top: 10px" src="../../static/image/leftbar_menu/icon_FULFILLMENT_notext.svg" alt="FULFILLMENT"/>
          </div>
          <div class="metric-title">Required Actions</div>
        </div>
        <div class="metric-item" v-for="(count, ACTION_REQUIRED_BY) in groupedTrackingCount" :key="ACTION_REQUIRED_BY">
          <span class="metric-label">{{ ACTION_REQUIRED_BY }}</span>
          <!--<span class="metric-value review">{{ count }}</span>-->
          <b-button class="metric-value review" @click="showDetails(ACTION_REQUIRED_BY)">
            {{ count }}
          </b-button>
          <!-- 展開詳細 -->
          <!--<ul v-if="expanded[category]">
            <li v-for="item in groupedData[category]" :key="item.id">
              {{ item.title }}
            </li>
          </ul>-->
        </div>
        <b-modal id="details-modal" v-model="modalVisible" size="lg" :title="modalTitle" @cancel="cleanMpsData">
          <b-table striped hover :items="modalItems" :fields="fields" ref="myTable">
            <template #cell(FTIE_ID)="data">
              <div class="row">
                <div class="d-flex align-items-center justify-content-start col-4 align-self-end">
                  <span class="cursor-pointer fw-bold btn btn-sm btn-outline-secondary pb-1" role="button"
                        @click="getMpsInfo(data, data.item.FTIE_ID)">
                    {{ data.detailsShowing ? '˄' : '˅' }}
                  </span>
                  <a class="link" target="_blank" :href="`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.FTIE_ID }`">{{ data.item.FTIE_ID }}</a>
                </div>
              </div>
            </template>
            <template #row-details="row">
              <b-spinner v-if="row.item.loading" small />

              <div v-else>
                <div v-for="(item, index) in row.item.details" :key="index" class="mb-2">
                  <div v-if="index === 0" class="font-weight-bold  mb-1">
                    {{ item.OPPORTUNITY_NAME }}
                  </div>

                  <div class="row">
                    <div class="col-3">{{ item.MPS_DATE | dateFormat}}</div>
                    <div class="col-3 text-end">QTY-{{ item.QUANTITY }}</div>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
        </b-modal>
        <!--<div class="metric-item">
          <span class="metric-label">Awaiting Review</span>
          <span class="metric-value review">{{ actionMetrics.awaitingReview }}</span>
        </div>

        <div class="metric-item">
          <span class="metric-label">Escalated</span>
          <span class="metric-value escalated">{{ actionMetrics.escalated }}</span>
        </div>

        <div class="metric-item">
          <span class="metric-label">Follow-up Required</span>
          <span class="metric-value pending">{{ actionMetrics.followUp }}</span>
        </div>-->

      </div>
    </div>

    <!-- Bottom Block: Release Notes -->
    <div class="release-notes-block">
      <div class="release-notes">
        <h2>Release Notes</h2>

        <div v-if="releaseNotes.length === 0" class="loading">
          Loading release notes...
        </div>

        <div v-for="release in releaseNotes" :key="release.id" class="release-item">
          <div class="release-date">{{ release.date }}</div>
          <div class="release-title">{{ release.title }}</div>
          <div v-if="release !== null && release.description !== null && release.description.includes('</')" class="release-description" v-html="release.description"></div>
          <div v-else class="release-description">{{ release.description }}</div>
        </div>
      </div>
    </div>


    <!-- Admin Reports Section (NEW DESIGN) -->
    <br />
    <div v-if="downloadReportAccess()" class="metrics-row">
      <div class="metric-card" style="width: 200%;">
        <div class="metric-header">
          <div class="metric-icon tickets">
            <img style="width: 114%; padding-top:10px" src="../../static/image/leftbar_menu/icon_CASE SHARING_notext.svg" alt="CASE SHARING"/>
          </div>
          <div class="metric-title">Manager Report for Analysis (Permission Required)</div>
        </div>

        <div class="metric-item" v-if="downloadReportAccess()">
          <span class="metric-label">FTIE x Windows Autopilot Analysis Report</span>
          <span class="metric-value pending clickable-link" @click="getManagerReport('MSFT AUTOPILOT')">Click to Download</span>
        </div>

        <div class="metric-item" v-if="downloadReportAccess()">
          <span class="metric-label">DDM Sow Report</span>
          <span class="metric-value pending clickable-link" @click="getDdmSowReport()">Click to Download</span>
        </div>

        <div class="metric-item" v-if="downloadReportAccess()">
          <span class="metric-label">FTIE and Request Form Report</span>
          <span class="metric-value pending clickable-link" @click="getManagerReport('FTIE REQ FORM')">Click to Download</span>
        </div>

        <div class="metric-item" v-if="downloadReportAccess()">
          <span class="metric-label">ETO NRE Report</span>
          <span class="metric-value pending clickable-link" @click="getManagerReport('NRE QUOTE STATUS')">Click to Download</span>
        </div>
      </div>
    </div>

    <!-- Bottom Block: ETO Definations
        <div class="release-notes-block">
  </div>
    -->


  </div>
</template>


<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'homepage',
    data() {
      return {
        ticketMetrics: {
          pending: 0,
          assigned: 0,
          resolved: 0,
          overdue: 0
        },
        actionMetrics: {
          awaitingReview: 0,
          escalated: 0,
          followUp: 0,
          customerResponse: 0
        },
        releaseNotes: [],
        mainProps: {
          center: true,
          fluidGrow: true,
          blank: true,
          blankColor: '#bbb',
          width: 600,
          height: 400,
          class: 'my-5'
        },
        slide: 0,
        sliding: null,
        function_name: 'Home',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO: '',
        GROText: '',
        GRO_owner: '',
        GTC_owner: '',
        login_user_name: '',
        //releaseNotes: null,
        etoDefinition: null,
        user_email: this.$session.get('user_id'),
        user_name: this.$session.get('user_name'),
        user_functions: this.$session.get('user_functions'),
        user_roles: this.$session.get('user_roles'),
        user_site: this.$session.get('user_site'),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        azureDevOpsPrjs: null,
        defaultLogs: [],
        unreadFTIEs: [],
        pendingNREs: [],
        modalVisible: false,
        modalTitle: "",
        modalItems: [],
        fields: ["FTIE_ID", "ACTION_REQUIRED_BY"],
        ftieModalVisible: false,
        ftieFields: ["FTIE_ID"], // b-table 欄位定義
        nreModalVisible: false,
        nreFields: ["NRE_ID"], // b-table 欄位定義
        hasUpdate: false,
        mps_list:[]
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.getStatusOverview();
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadMetrics();
      // this.loadReleaseNotes();

    },
    computed: {
      groupedTrackingData() {
        return _.groupBy(this.defaultLogs, "ACTION_REQUIRED_BY");
      },
      groupedTrackingCount() {
        return _.mapValues(this.groupedTrackingData, g => g.length);
      }
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      /*
       *
      tooltipTitle(data, stage_index) {
        let self = this;
        var signing_stage = data.item.signing_stages[stage_index];
        return _.trim(self.stageTip[stage_index] + ' ' + _.trim(_.get(signing_stage, 'status_name', '')))
      },
       */
      loadMetrics() {
        // Simulate API call to fetch ticket metrics
        setTimeout(() => {
          this.ticketMetrics = {
            pending: 24,
            assigned: 18,
            resolved: 156,
            overdue: 3
          };

          this.actionMetrics = {
            awaitingReview: 7,
            escalated: 2,
            followUp: 12,
            customerResponse: 9
          };
        }, 1000);
      },

      /*
            formatDate(date) {
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      },
      */


      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },

      tooltipReason(data) {
        let self = this;
        return _.trim(_.get(data.item, 'reject_reason', ''))
      },

      downloadReportAccess() {
        let self = this;

        if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1) {
          return true
        }

        if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1
          && (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)) {
          console.log("downloadReportAccess")
          return true;
        } else {
          console.log("downloadReportAccess permission denied")
          return false
        }
      },
      getStatusOverview() {

        let self = this;
        let resultText = null;
        let url = self.$root.baseUrl + '/ftie/build-homepage/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let requestData = {
          user_name: self.login_user_name,
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            self.defaultLogs = data.dashboard_data;
            self.unreadFTIEs = data.unread_data;
            self.pendingNREs = data.pending_nre_data;
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getDdmSowReport() {

        let self = this;
        if (self.downloadReportAccess() === false) {
          self.$message.error('Please contact system admin to grant you the access!', 'Permission Error');
          return false;
        }
        let resultText = null;
        let url = self.$root.baseUrl + '/admin-member/ddm-sow-report/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          downloadTime: downloadTime,
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'ddm_sowt_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getManagerReport(purpose) {

        let self = this;
        if (self.downloadReportAccess() === false) {
          self.$message.error('Please contact system admin to grant you the access!', 'Permission Error');
          return false;
        }
        let resultText = null;
        let url = self.$root.baseUrl + '/nre-fulfillment/autopilot/report/download/';
        console.log("purpose" + purpose);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          downloadTime: downloadTime,
          download_purpose: purpose
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = purpose + '_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        var release_notes = this.$session.get('release_notes');
        var eto_definition = this.$session.get('eto_definition');

        // console.log(options.model_list);
        // console.log("login_user_name:");
        // console.log(user_name);
        // console.log("user_email:");
        // console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        this.releaseNotes = release_notes;
        this.etoDefinition = eto_definition;
      },
      showDetails(category) {
        this.modalTitle = `${category}`;
        this.modalItems = this.groupedTrackingData[category] || [];
        this.modalVisible = true;
      },
      showFtieDetails() {
        this.ftieModalVisible = true;
      },
      showNreDetails() {
        this.nreModalVisible = true;
      },
      changeUpdateStatus(status) {
        this.hasUpdate = status;
      },
      getMpsInfo(row, ftie_id) {
        let self = this;
        if (!row.detailsShowing) {
          this.$set(row.item, 'loading', true)


          let resultText = null;
          let url = self.$root.baseUrl + '/opportunity/back-end/mps/';
          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          let requestData = {
            ftie_id: ftie_id,
          };
          eventHub.$emit('loading', true);
          self.$axios
            .post(url, requestData)
            .then(resRead => {
              //console.log(resRead);
              if (_.get(resRead, 'status', 0) !== 200) return;
              let data = resRead.data;
              self.$set(row.item, 'details', data.mps_list)
            })
            .finally(() => {
              eventHub.$emit('loading', false);
              row.toggleDetails()
            });
          self.$set(row.item, 'loading', false)

        } else {
          self.$set(row.item, '_showDetails', false);
        }
      },
      cleanMpsData() {
        let self = this;
        self.modalItems.forEach(item => {
          item._showDetails = false;
          item.details = [];
        });
      }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomePageTicketOverview.vue